<template>
  <div class="home">
    <div class="container">
      <div class="row">
        <div class="col-md-8 col-12">
          <MyProfileCard v-if="this.isLoggedIn && this.currentUser && this.currentUser.id"></MyProfileCard>
          <MyMatches v-if="this.isLoggedIn && this.currentUser && this.currentUser.id"></MyMatches>

          <div class="row row-play" v-if="this.isLoggedIn">
            <div class="col-md-6" v-if="false">
              <div :class="`anticheat-box ${this.isAnticheatRunning ? 'running' : 'not-running'}`">
                <div v-if="isAnticheatRunning">
                  <h4>
                    anticheater rodando,
                    <br>bora jogar
                  </h4>
                </div>
                <div v-else>
                  <a v-b-modal.anticheatModal>
                    <h5>abra o anticheater e o CS</h5>
                    <small>o CS precisa estar fechado</small>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="playnow-box" @click="openPlayModal">
                <h1>Jogar agora</h1>
              </div>
            </div>
          </div>

          <div class="row row-ads" v-if="this.isLoggedIn">
            <div class="col-12 col-md-6">
              <router-link :to="{ name: 'PracticeList' }" class="practice-box">
                <b-img src="/img/cs-players.png"/>
                <div class="content">
                  <h3>procure treino</h3>
                  <p>encontre um time para treinar com o seu</p>
                </div>
              </router-link>
              <router-link :to="{ name: 'PremiumPage' }" class="training-box" v-if="false">
                <b-img src="/img/grenade-he.png"/>
                <div class="content">
                  <h3>servidores treino</h3>
                  <p>libere um servidor tick 128 agora para treinar com seu time</p>
                </div>
              </router-link>
            </div>
            <div class="col-12 col-md-6">
              <BlogpostCarousel></BlogpostCarousel> 
              
            </div>
          </div>

          <div class="row row-widgets" v-if="this.isLoggedIn && true">
            <div class="col-12 col-md-6">
              <FeaturedMatches></FeaturedMatches>
            </div>
            <div class="col-12 col-md-6">
              <MiniRanking :players="topRankedPlayers"></MiniRanking>
            </div>
          </div>

          <div class="home-marketing" v-if="!this.isLoggedIn">
            <div class="row">
              <div class="col-12 col-md-3">
                <div class="home-logo">
                  <b-img src="/img/queota-gradient.png"/>
                </div>
              </div>
              <div class="col-12 col-md-9">
                <div class="home-content">
                  <h1>CS:GO Competitivo é aqui</h1>
                  <h2>
                    <strong>Lugar pra quem joga sério</strong>
                  </h2>

                  <ul class="list-unstyled">
                    <li>Os melhores servidores tickrate 128</li>
                    <li>Anticheater próprio</li>
                    <li>Organize campeonatos</li>
                    <li>Jogue em grupos</li>
                  </ul>

                  <small>
                    <p>Estamos criando uma nova plataforma para melhorar o dia a dia e o treino dos times e o jogo individual de nossos atletas.</p>
                    <p>O QUEOTA está em <strong>beta público</strong>.</p>
                  </small>

                  <b-button
                    class="main-cta"
                    variant="dark"
                    size="lg"
                    :to="{ name: 'Login' }"
                  >Entre e jogue AGORA</b-button>
                </div>
              </div>
            </div>
          </div>
          <div class="section join-us" v-if="!this.isLoggedIn">
            <h3>
              e junte-se a essa galera que joga aqui
              <small>(e muitos mais...)</small>
            </h3>
            <div class="members-list">
              <div class="member" v-for="user in latestUsers" :key="user.slug">
                <router-link
                  :to="{ name: 'UserSingle', params: { id: user.to_param }}"
                  class="user-card"
                  v-b-tooltip.hover
                  :title="user.nickname"
                >
                  <div class="user-image">
                    <b-img :src="user.avatar.url" :alt="user.nickname"/>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <div class="numbers-section" v-if="!this.isLoggedIn">
            <div class="row justify-content-center">
              <div class="col-2">
                <h4>6300+</h4>
                <p class>usuários</p>
              </div>
              <div class="col-2">
                <h4>520+</h4>
                <p class>times</p>
              </div>
              <div class="col-2">
                <h4>2100+</h4>
                <p class>partidas</p>
              </div>
            </div>
          </div>

          <!-- <div class="section tournaments" v-if="!this.isLoggedIn">
            <h2>Organize seu campeonato</h2>

            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi, possimus iste porro vitae laborum eligendi? Laboriosam, recusandae animi? Consectetur esse natus porro tenetur beatae eligendi eos animi error ullam quo?</p>
          </div>

          <div class="section training" v-if="!this.isLoggedIn">
            <h2>Treine com seu time</h2>

            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Tenetur enim nostrum ab, voluptatum deleniti asperiores perferendis quam eos dolor ullam dicta amet laborum ex ipsum laudantium id, cum, illo quae?</p>
          </div>

          <div class="section clubs" v-if="!this.isLoggedIn">
            <h2>Jogue em grupos</h2>

            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed, autem incidunt. Impedit illo laborum veritatis eius molestias. Esse necessitatibus unde voluptas nostrum totam, ipsa ipsum consectetur modi veniam. Eum, error!</p>
          </div>
        </div>
        <div class="col-md-4 col-12">
          
          
          <ForfunServerList></ForfunServerList>
        </div>-->
        <div class="row justify-content-center">
          <div class="col-md-8 col-12">
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import BlogpostCarousel from "@/components/BlogpostCarousel.vue";
import TournamentCarousel from "@/components/TournamentCarousel.vue";
import MyProfileCard from "@/components/MyProfileCard.vue";
import MyMatches from "@/components/MyMatches.vue";
import ForfunServerList from "@/components/ForfunServerList.vue";
import MatchmakingWidget from "@/components/MatchmakingWidget.vue";
import FeaturedMatches from "@/components/FeaturedMatches.vue";
import MiniRanking from "@/components/MiniRanking.vue";

export default {
  name: "Home",
  computed: {
  },
  data() {
    return {
      teams: null,
      topRankedPlayers: [],
      latestUsers: []
    };
  },
  methods: {
    openPlayModal() {
      if (!this.isAnticheatRunning) this.$emit("openModal", "anticheat");
      else this.$emit("openModal", "play");
    },
    initialize() {
      this.$http
        .get("top_ranked.json")
        .then(response => (this.topRankedPlayers = response.data));

      this.$http
        .get("latest_users.json")
        .then(response => (this.latestUsers = response.data.users));

      if (this.currentLobby.id) {
        this.$http
          .get(`lobbies/${this.currentLobby.id}.json`)
          .then(response => {
            if (!response.data.live) this.$store.dispatch("leaveLobby", true);
          });
      }
    }
  },
  mounted() {
    this.initialize();
  },
  components: {
    BlogpostCarousel,
    TournamentCarousel,
    MyProfileCard,
    MatchmakingWidget,
    MyMatches,
    FeaturedMatches,
    ForfunServerList,
    MiniRanking
  }
};
</script>

<style lang="sass" scoped>
$blue: #1985A1
$bluer: #2B59C3
$purple: #522D82

.home .container 
  padding-top: 40px

.home-marketing
  .home-logo
    img
      width: 100%
      max-width: 120px
  .home-content
    color: #ccc
    h1, h2
      color: white
    h1
      margin-bottom: 0px
    h2
      margin-bottom: 40px
    ul
      margin-bottom: 40px
      li
        line-height: 200%

    .main-cta
      background: darken($bluer, 0%)
      padding: 14px 18px
      border: 0
.join-us
  margin: 40px 0 20px
  h3
    text-align: center
    margin: 20px 0
    font-size: 14px
    text-transform: lowercase
    font-family: inherit
    font-weight: normal

  .members-list
    display: flex
    flex-wrap: wrap
    // justify-content: space-between
    a
      position: relative
      cursor: pointer
      img
        width: 32px
        height: 32px
        border-radius: 100%
        opacity: .15
        transition: all .1s
        cursor: pointer
      &:hover
        img
          opacity: 1
          transform: scale(1.1)

.section:not(.numbers):not(.join-us)
  margin: 20px 0
  padding: 10px 0
  h2
    text-align: center
.numbers-section
  text-align: center
  h4
    margin: 0
  p
    margin: 0
  // display: flex
  // @media (max-width: 600px)
  //   flex-wrap: wrap
  // .home-logo
  //   width: 140px
  //   margin-right: 40px
  //   @media (max-width: 600px)
  //     width: 100%
  //     height: auto
  //     margin-right: 0
  // .home-content
  //   margin-right: 40px
  //   flex: 1
    
  //   h1, h2
  //     margin: 0
  //     color: #999

  //   p
  //     margin-bottom: 5px

  //   ul.features
  //     padding: 0
  //     margin-top: 10px
  //     li
  //       list-style: none
  //       line-height: 30px
  //       font-weight: 600
  //       color: rgba(0, 0, 0, .8)

  //       i.fa 
  //         color: rgba(green, .7)
  //         font-weight: normal
  //         display: inline-block
  //         margin-right: 3px
  //         font-size: 13px
    
  //   a.btn
  //     border-color: rgba(255, 255, 255, 0.07)
  //     // background: linear-gradient(180deg, rgba(96, 96, 96, 1) 15%, rgba(51, 51, 51, 1) 66%)
  //     background: rgb(4,161,4)
  //     background: linear-gradient(5deg, rgba(4,164,4,1.8673844537815126) 35%, rgba(5,51,5,0.8869922969187675) 66%)
  //     // animation: Gradient 2s ease infinite
  //     background-size: 200% 200%

  //     border-bottom: 1px solid transparent
  //     outline: 0
  //     &:hover
  //       background: #333

.home-video
  max-width: 400px
  margin-top: 40px
  @media (max-width: 600px)
    max-width: 300px
    margin-bottom: 20px

@keyframes Gradient
  0%
    background-position-y: 0px
  50%
    background-position-y: -20px
  100%
    background-position-y: 0px
.row-widgets
  margin-top: 40px
.row-play
  margin-top: 20px
  .anticheat-box
    &:before
      content: '1'
      color: rgba(255, 255, 255, .4)
      font-family: 'Oswald', monospace
      font-size: 11px
      position: absolute
      top: 4px
      left: 20px
    a
      margin: 0
      padding: 10px
      background: rgba(#dfdfdf, .15) url('/img/icons/mstile-310x310.png') no-repeat right center
      background-size: 130px
      background-position-x: 200px
      border-radius: 4px
      transition: all .25s
      color: white
      display: flex
      align-items: center
      border: 1px solid transparent
      height: 70px
      position: relative
      cursor: pointer

      h5
        color: rgba(darken(white, 1), .3)
        line-height: 100%
        max-width: 100px
        margin-bottom: 0
        transition: all .25s
      small
        position: absolute
        bottom: 4px
        font-size: 10px
        opacity: 0
        transition: all .7s ease

      &:hover
        background: rgba(#0f0f0f, .675) url('/img/icons/mstile-310x310.png') no-repeat right center
        background-size: 150px
        background-position-x: 210px
        text-decoration: none
        
        h5
          color: white
        small
          opacity: 1


  .playnow-box
    margin: 0
    padding: 10px
    height: 70px
    opacity: .75
    cursor: pointer

    border-radius: 4px
    transition: all .25s

    background: rgb(4,161,4)
    background: linear-gradient(0deg, rgba(4,164,4,.9) 65%, rgba(5,51,5,0.8) 96%)
    animation: Gradient 3s ease infinite
    background-size: 200% 200%
    border: 1px solid transparent

    color: white
    display: flex
    flex-wrap: wrap
    align-items: center
    justify-content: center

    &:before
      content: '2'
      color: rgba(255, 255, 255, .4)
      font-family: 'Oswald', monospace
      font-size: 11px
      position: absolute
      top: 4px
      left: 20px

    h1
      margin: 0
      text-transform: uppercase
      font-size: 30px
      // color: rgba(lightgreen, .9)
      color: white
      transition: all .8s
    
    &:hover
      opacity: 1
      background: rgba(4,164,4,.9)
      

.row-ads
  margin-top: 40px
  .training-box
    border-radius: 4px
    position: relative
    min-height: 120px
    // cursor: pointer
    display: block
    color: rgba(255, 255, 255, .5)
    margin-top: 80px
    img
      position: absolute
      z-index: 3
      transition: all .4s
      // top: -100px
      // left: -110px
      transform: scale(0.7) translateX(-170px) translateY(-150px)
    .content
      transition: all .2s ease-in-out
      position: absolute
      z-index: 4
      background: rgba(0, 0, 0, .4)
      width: 100%
      height: 100%
      padding: 20px

    &:hover
      img
        z-index: 5
        transform: scale(1) translateX(-100px) translateY(-110px)
      .content
        transform: scale(1.1)
        background: rgba(0, 0, 0, .95)
        padding-top: 80px
        min-height: 200px

  .practice-box
    border-radius: 4px
    position: relative
    min-height: 120px
    // cursor: pointer
    display: block
    color: rgba(255, 255, 255, .5)
    margin-top: 40px
    img
      position: absolute
      z-index: 3
      transition: all .4s
      transform: scale(0.4) translateX(-390px) translateY(-375px)
    .content
      transition: all .2s ease-in-out
      position: absolute
      z-index: 4
      background: rgba(0, 0, 0, .4)
      width: 100%
      height: 100%
      padding: 20px

    &:hover
      img
        transform: scale(0.5) translateX(-320px) translateY(-445px)
      .content
        transform: scale(1.1)
        background: rgba(0, 0, 0, .95)
        // padding-top: 80px
        min-height: 140px
</style>

